import ApiService from "./apiservice";

export const AuthService = {
    login(_username, _password,_loginType) {
        //encode to base64
        //_password = btoa(_password)

        const headers = {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        // //debugger
        // if(_password){

        // }
        
        const params = new URLSearchParams();
        params.append('username', _username);
        params.append('password', _password);
        params.append('loginType', _loginType);

        //return ApiService.post("LoginPersonel", params, headers);
        return ApiService.post("NewLoginPersonel", params, null,headers);
    },
    TestConnection(){
        return ApiService.get("test");
    },
    TestPass(){
        return ApiService.get("login/TestPass");
    }
};